<rr-spinner *ngIf="isLoading"></rr-spinner>

<div class="dialog-header" i18n>
    <div class="row space-between">
        <div>
            <div class="row gap-8 align-center">
                @if (
                    data.activeFounder.prename || data.activeFounder.lastname
                ) {
                    <h2 class="strong">
                        {{ data.activeFounder.prename }}
                        {{ data.activeFounder.lastname }}
                    </h2>
                }
                <rr-badge tone="success">Access Status: Granted</rr-badge>
                @if (data.activeFounder.userGateProgress) {
                    <rr-badge tone="information"> User with Gates </rr-badge>
                }
            </div>
            <div>
                {{ data.activeFounder.email }} | Accepted:
                {{ data.activeFounder.connectionCreated | date }}
            </div>
        </div>

        <div class="row gap-8 align-center">
            <rr-btn type="link" size="small" (btnclick)="revokeAccess()"
                >Revoke Access</rr-btn
            >
            <rr-btn
                iconStart="close"
                size="small"
                type="secondary"
                (btnclick)="close()"
                >Close</rr-btn
            >
        </div>
    </div>
</div>

@if (data.activeFounder.customLoginFormData?.length) {
    <div class="col w100">
        <h3>Registration information</h3>
        <div class="usergatecontent w100 col gap-8">
            @for (
                field of data.activeFounder.customLoginFormData;
                track field.id
            ) {
                <div class="row space-between w100">
                    <span class="strong">{{ fieldLabel(field.id) }}</span>
                    <span>{{ field.value || '-' }}</span>
                </div>
            }
        </div>
    </div>
}

@if (data.activeFounder.userGateProgress) {
    <div class="col w100">
        <div class="row space-between align-center w100 gap-16">
            <div class="row gap-16 align-center">
                <h3 class="w100">User gates</h3>
                @if (checkIfUserWaitsOnGate().waiting) {
                    <rr-badge tone="error">User waits on Gate</rr-badge>
                }
            </div>
            @if (showUserGateContent === true) {
                <rr-icon
                    name="close"
                    (click)="showUserGateContent = false"
                ></rr-icon>
            } @else {
                <rr-btn
                    size="small"
                    type="secondary"
                    (btnclick)="showUserGateContent = true"
                    >Show User Gate Content</rr-btn
                >
            }
        </div>
        @if (showUserGateContent === true) {
            <div class="usergatecontent w100 col gap-8">
                @for (
                    gate of data.activeFounder.userGateProgress;
                    track gate.name;
                    let i = $index
                ) {
                    <div class="col space-between align-start gap-4 gate">
                        <div class="row space-between w100 align-center">
                            <span class="strong whitespace">{{
                                gate.name
                            }}</span>
                            @if (
                                gate.closed === true &&
                                gate.confirmedByCoach === true
                            ) {
                                <rr-badge tone="success"
                                    >Gate is finished</rr-badge
                                >
                            } @else if (
                                gate.closed === false &&
                                gate.confirmedByCoach === true
                            ) {
                                <rr-badge tone="warning"
                                    >Gate in progress</rr-badge
                                >
                            } @else if (
                                gate.closed === false &&
                                gate.confirmedByCoach === false &&
                                checkIfUserWaitsOnGate().waiting === true &&
                                checkIfUserWaitsOnGate().index === i
                            ) {
                                <rr-btn
                                    type="primary"
                                    size="small"
                                    (click)="activateGate(i)"
                                    >Activate Gate</rr-btn
                                >
                            }
                        </div>
                        <rr-divider></rr-divider>
                        <div class="col gap-4 w100 streamlist">
                            @for (
                                stream of gate.streamIdList;
                                track stream.streamId
                            ) {
                                <div class="row space-between w100">
                                    <span>{{ stream.streamName }}</span>
                                    @if (
                                        stream.closed === true &&
                                        gate.closed === false
                                    ) {
                                        <rr-icon name="check-circle"></rr-icon>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        }
    </div>
}
<div class="dialog-content">
    <h3>{{ finishedStreams.length }} Stream(s)</h3>

    <div class="list-wrapper col gap-32 w100">
        @if (finishedStreams.length === 0) {
            <p>The user hasn't completed any streams yet.</p>
        } @else {
            @for (
                userStream of finishedStreams;
                track userStream.id;
                let index = $index
            ) {
                <app-generic-stream-result
                    [streamData]="streamsData[index]"
                    [userStream]="userStream"
                    [userId]="data.activeFounder.id"
                    [isCoachAccess]="true"
                    (isLoading)="isLoading = $event"
                >
                </app-generic-stream-result>
            }
        }
    </div>
</div>
